function showToggler(){
    $('.ShowMore').each(function(){
        let wrapperHeight = $(this).find('.ShowMore-content-wrapper').height();
        let contentHeight = $(this).find('.ShowMore-content').height();

        if ( wrapperHeight >= contentHeight )
        {
            $(this).addClass('ShowMore-opened');
        }

    });
}

$(function () {

    showToggler();

    $(window).on('resize', function(){
        showToggler();
    });

    $('.ShowMore-toggler').on('click', function(e){
        e.preventDefault();
        $(this).parents('.ShowMore').addClass('ShowMore-opened');
    });

});